import type { PropsWithChildren } from 'react';
import { SaveViewButton } from '../saveViewFeature';
import { ViewBadge } from '../saveViewFeature/ViewBadge';

type HeaderProps = {
  actions?: React.ReactNode;
};

export const Header = ({ children, actions }: PropsWithChildren<HeaderProps>) => (
  <header className="mx-6 my-4 flex h-11 shrink-0 items-center gap-2">
    <h3 className="text-t24-sb">{children}</h3>
    <ViewBadge />
    <SaveViewButton />
    {actions}
  </header>
);
